import { render } from "./AboutLayout.vue?vue&type=template&id=f1821d52"
const script = {}

import "./AboutLayout.vue?vue&type=style&index=0&id=f1821d52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__